import { Routes } from '@angular/router';
import { MyProfileComponent } from './my-profile/my-profile.component';
import { MemberComponent } from './member/member.component';
import { MemberProfileComponent } from './member-profile/member-profile.component';
import { MemberListComponent } from './member-list/member-list.component';
import { ActivityTabComponent } from './activity-tab/activity-tab.component';
import { ProfileTabComponent } from './profile-tab/profile-tab.component';
import { MediaTabComponent } from './media-tab/media-tab.component';
import { FriendsTabComponent } from './friends-tab/friends-tab.component';
import { SearchTabComponent } from './search-tab/search-tab.component';
import { MessageTabComponent } from './message-tab/message-tab.component';
import { AuthGuard } from './auth.guard';
import { SocketComponent } from './socket/socket.component';
import { HomeComponent } from './home/home.component';



export const routes: Routes = [
    { path: 'member-profile/:username/:tab', component: MemberProfileComponent, canActivate: [AuthGuard] },
    { path: 'my-profile/:username/:tab', component: MyProfileComponent, canActivate: [AuthGuard] },
    { path: 'members', component: MemberListComponent, canActivate: [AuthGuard] },
    { path: 'socket', component: SocketComponent, canActivate: [AuthGuard] },
    { path: 'home', component: HomeComponent, canActivate: [AuthGuard] },
    { path: '', component: HomeComponent},
];
